var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9869 1H2.01306C1.81195 1.00275 1.6161 1.06297 1.44977 1.17317C1.28345 1.28338 1.15397 1.43874 1.07739 1.61999C1.00081 1.80123 0.980501 2.0004 1.01897 2.19279C1.05744 2.38518 1.15301 2.56233 1.29382 2.70229L6.73952 8.71038L6.94502 9.41132V14.2178C6.94502 14.4181 6.94502 14.6183 7.15052 14.6183L10.233 16.9214C10.5412 17.1217 11.055 16.9214 11.055 16.5209V9.41132C11.055 9.11092 11.055 8.91065 11.2605 8.71038L16.7062 2.70229C16.847 2.56233 16.9426 2.38518 16.981 2.19279C17.0195 2.0004 16.9992 1.80123 16.9226 1.61999C16.846 1.43874 16.7165 1.28338 16.5502 1.17317C16.3839 1.06297 16.188 1.00275 15.9869 1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.75498151d20b9c875b7ae331a70261bf.svg";
export { ForwardRef as ReactComponent };